<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[{ name: 'Alert Info', to: { path: '/alert-info' } }]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>Alert Info</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>
    <div class="block">
      <!-- Title -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">鄭重聲明</div>
      </div>
      <!-- Content -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Content</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          一、本公司發現近日來有不肖商人違法濫用威剛公司之節能標章證書，
          於Facebook臉書及特定網頁上廣告宣傳販售非威剛公司生產之冷氣機商品，
          誤導消費者認知及消費行為，造成本公司與消費者之困擾，本公司已採取相關反制措施。
          <br /><br />
          二、關於該等來源不清且標示不明之商品品質及效能等，威剛公司善意提醒消費者應審慎留意、
          斟酌並檢視廣告內容，以免自身權益受到損害。
        </div>
      </div>
      <!-- 開始日期 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>開始日期</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">2020.08.01</div>
      </div>
      <!-- 結束日期 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>結束日期</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">2020.08.08</div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    Breadscrumbs,
  },
  methods: {
    editHandler() {
      this.$router.push('/alert-info/edit');
    },
  },
};
</script>

<style></style>
